import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import {
    getMyJobApplications,
    updateApplicationToComplete
} from "../../../../../../actions/jobs/jobs";

class AppliedForm extends Component {
    state = {
        app_job: 0,
        error: false
    };

    onChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    postApplied = e => {
        e.preventDefault();
        const {
            updateApplicationToComplete,
            getMyJobApplications,
            options
        } = this.props,
            person_id = localStorage.getItem("person_id");
        if (this.state.app_job === 0) {
            return this.setState({ error: true });
        }
        updateApplicationToComplete(
            person_id,
            this.state.app_job,
            this.props.job_id
        );
        getMyJobApplications(options, 1, person_id);
    };

    render() {
        return (
            <React.Fragment>
                <div className="mt-1">
                    {this.state.error && (
                        <div className="alert alert-danger small">
                            Choose application status to update.
            </div>
                    )}
                </div>
                <form className="form-status-application">
                    <ul className="status-update">
                        <li className="status-update__input">
                            <select className="form-control" name="app_job" onChange={this.onChange} defaultValue={1}>
                                <option value={1}>I've applied for this job</option>
                                <option value={5}>I haven't applied for this job</option>
                            </select>
                        </li>
                        <li className="status-update__button">
                            <button
                                className="theme-button"
                                onClick={this.postApplied}
                            >Update</button>
                        </li>
                    </ul>
                </form>
            </React.Fragment>
        );
    }
}

AppliedForm.propTypes = {
    getMyJobApplications: PropTypes.func,
    updateApplicationToComplete: PropTypes.func,
    job_id: PropTypes.number,
    options: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]),
};

const mapStateToProps = state => {
    return {
        options: state.jobs.options
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getMyJobApplications: (options, page, person_id, jobId) =>
            dispatch(getMyJobApplications(options, page, person_id, jobId)),
        updateApplicationToComplete: (personId, status, jobId) =>
            dispatch(updateApplicationToComplete(personId, status, jobId))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AppliedForm);



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/AppliedForm.js